import React from "react";
import { ThemeContext } from "../../utils/theme-context";
import { Toggle, ListItem } from "@ui-kitten/components";

export const ThemeToggle = () => {

    const themeContext = React.useContext(ThemeContext);

    const renderAccessory = (style, index) => (
        <Toggle
            checked={themeContext.theme === 'dark'}
            onChange={themeContext.toggleTheme}
        />
    );

    return (
        <ListItem
            title='Dark Mode'
            accessory={renderAccessory}
        />
    );
};